// Translation files for English and Hindi
export const translations = {
  en: {
    // Navigation
    home: "Home",
    library: "Library",
    temples: "Temples",
    astrology: "Astrology",
    live: "Live",
    contactUs: "Contact Us",
    login: "Login",
    logout: "Logout",
    dashboard: "Dashboard",
    myProfile: "My Profile",
    profile: "Profile",
    
    // Live Page
    liveStream: "Live Stream",
    liveStreamDescription: "Join us for our live spiritual sessions and ceremonies",
    aboutThisLiveStream: "About This Live Stream",
    liveStreamAboutText: "Welcome to our live spiritual session. Here you can participate in real-time prayers, ceremonies, and spiritual discussions. Our experienced priests and spiritual guides will be conducting various rituals and answering your questions.",
    schedule: "Schedule",
    participation: "Participation",
    dailyPrayers: "Daily prayers: 6:00 AM - 7:00 AM",
    eveningAarti: "Evening aarti: 7:00 PM - 8:00 PM",
    participationText: "Feel free to join in prayers, ask questions in the chat, and participate in the spiritual journey with us.",
    
    // Live Videos
    currentlyLive: "Currently Live",
    noLiveVideos: "No live videos at the moment",
    watch: "Watch",
    liveStatus: "LIVE",
    refresh: "Refresh",
    loading: "Loading...",
    
    // Video Detail Page
    watchLive: "Watch Live",
    description: "Description",
    readMore: "Read More",
    readLess: "Read Less",
    backToLive: "Back to Live",
    
    // Library Sections
    sanatanSahitya: "Sanatan Sahitya",
    readAllArticles: "Read all Articles",
    arti: "Arti",
    artiDescription: "Devotional songs and prayers",
    chalisa: "Chalisa",
    chalisaDescription: "Forty verses praising the divine",
    mantra: "Mantra",
    mantraDescription: "Sacred sounds and vibrations",
    incarnations: "Incarnations of gods and goddesses",
    incarnationsDescription: "Stories of divine manifestations",
    spiritualStories: "Spiritual Stories",
    spiritualStoriesDescription: "Ancient wisdom and teachings",
    meditation: "Meditation",
    meditationDescription: "Guided spiritual practices",
    
    // Common
    exploreAnantAradhyaServices: "Explore Ananta Aradhya services",
    helpAndSupport: "Help and support for Temple Services",
    youCanCallUs: "You can call us from 10 AM - 8 PM",
    emailUs: "Email us",
    whatsappUs: "Whatsapp us",
    toCheckAllAvailable: "To check all available temple services & offers:",
    loginCreateAccount: "Login / Signup",
    accountDetails: "Account details",
    
    // Video Detail Page
    views: "views",
    videoInfo: "Video Information",
    channel: "Channel",
    status: "Status",
    watchOnYouTube: "Watch on YouTube",
    
    // Panchang Page
    panchang: "Panchang",
    panchangDescription: "Daily astrological information and auspicious timings",
    detailedPanchang: "Detailed Panchang Information",
    vaara: "Day",
    sunrise: "Sunrise",
    sunset: "Sunset",
    moonrise: "Moonrise",
    moonset: "Moonset",
    nakshatra: "Nakshatra",
    tithi: "Tithi",
    karana: "Karana",
    yoga: "Yoga",
    lord: "Lord",
    name: "Name",
    vedicName: "Vedic Name",
    paksha: "Paksha",
    start: "Start",
    end: "End",
    
    // Live Darshan Page
    liveNow: "LIVE NOW",
    devoteesWatching: "devotees watching",
    liveDarshan: "Live Darshan",
    //liveDarshanDescription: "Experience divine darshan from sacred temples across India in real-time",
    watching: "watching",
    joinDivineExperience: "Join the divine experience",
    joinPrayer: "Join Prayer",
    share: "Share",
    audio: "Audio",
    fullscreen: "Fullscreen",
    nextEveningAarti: "Next: Evening Aarti at 6:00 PM",
    joinCommunity: "Join the Community",
    liveChat: "Live Chat",
    typeMessage: "Type your message...",
    prayerRequests: "Prayer Requests",
    submitPrayerRequest: "Submit Prayer Request",
    otherSacredTemples: "Other Sacred Temples (Coming Soon)",
    comingSoon: "Coming Soon",
    getNotifiedWhenMoreTemples: "Get Notified When More Temples Go Live",
    beFirstToExperience: "Be the first to experience divine darshan from these sacred temples",
    enterEmail: "Enter your email",
    notifyMe: "Notify Me",
    neverMissSacredMoment: "Never Miss a Sacred Moment",
    downloadAppForNotifications: "Download our app to get notifications for live darshans and special events",
    downloadApp: "Download App",
    enableNotifications: "Enable Notifications",
    divineConnection: "Divine Connection",
    footerDescription: "Connecting devotees with divine experiences through technology while preserving ancient traditions.",
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved.",
    
    // Homepage Content
    experienceDivineDarshan: "✨ Experience Divine Darshan Anytime, Anywhere",
    connectWithSacredTemples: "Connect with sacred temples, participate in live darshan, and receive blessings at your doorstep.",
    startYourJourney: "🔶 Start Your Journey",
    watchLiveDarshan: "⚪ Watch Live Darshan",
    bridgingTraditionWithTechnology: "Bridging Tradition with Technology",
    traditionTechnologySubtitle: "For centuries, temples have been at the heart of spirituality. Our platform brings sacred experiences to your digital doorstep, preserving ancient traditions while embracing modern convenience.",
    learnMore: "👉 Learn More",
    divineServicesAtYourFingertips: "Divine Services at Your Fingertips",
    liveDarshanTitle: "📡 Live Darshan",
    //liveDarshanDescription: "Join sacred darshans from anywhere in the world",
    joinNow: "Join Now",
    astrologyConsultationTitle: "🔮 Astrology Consultation",
    astrologyConsultationDescription: "Personalized guidance from experts",
    consultNow: "Consult Now",
    dailyPanchangTitle: "📅 Daily Panchang",
    dailyPanchangDescription: "Your daily spiritual calendar",
    viewPanchang: "View Panchang",
    trustedByPandits: "Trusted by Uchaith Pandits",
    whatDevoteesSay: "What Devotees Say",
    avirajReview: "The live darshan feature has transformed my daily prayers. I can now connect with my favorite temple even when traveling.",
    akashReview: "The temple services have made everything convenient and authentic. The experience is excellent.",
    featuredTemples: "Featured Temples",
    goldenTemple: "Golden Temple",
    amritsarPunjab: "Amritsar, Punjab",
    kashiVishwanath: "Kashi Vishwanath",
    varanasiUp: "Varanasi, UP",
    tirupatiBalaji: "Tirupati Balaji",
    tirupatiAp: "Tirupati, AP",
    meenakshiTemple: "Meenakshi Temple",
    maduraiTn: "Madurai, TN",
    viewAllTemples: "👉 View All Temples",
    beginSpiritualJourney: "Begin Your Spiritual Journey Today",
    joinMillionsDevotees: "Join millions of devotees experiencing divine blessings through our platform.",
    //downloadApp: "📲 Download App",
    exploreServices: "🌸 Explore Services",
    
    // Astrology Page
    vedicAstrology: "Vedic Astrology",
    discoverCosmicBlueprint: "Discover your cosmic blueprint and navigate life's journey with ancient wisdom",
    getFreeHoroscope: "Get Free Horoscope",
    consultAstrologer: "Consult Astrologer",
    todaysHoroscope: "Today's Horoscope",
    love: "Love",
    career: "Career",
    health: "Health",
    luckyNumber: "Lucky Number",
    luckyColor: "Lucky Color",
    astrologyServices: "Astrology Services",
    birthChartAnalysis: "Birth Chart Analysis",
    birthChartDescription: "Comprehensive analysis of your natal chart revealing personality traits, strengths, and life path.",
    loveCompatibility: "Love Compatibility",
    loveCompatibilityDescription: "Discover relationship compatibility and understand your romantic dynamics with detailed insights.",
    careerGuidance: "Career Guidance",
    careerGuidanceDescription: "Professional astrology consultation for career decisions, job changes, and business ventures.",
    gemstoneConsultation: "Gemstone Consultation",
    gemstoneConsultationDescription: "Personalized gemstone recommendations based on your birth chart for enhanced positive energy.",
    muhuratSelection: "Muhurat Selection",
    muhuratSelectionDescription: "Find the most auspicious timing for important events, ceremonies, and new beginnings.",
    remedialSolutions: "Remedial Solutions",
    remedialSolutionsDescription: "Powerful remedies including mantras, yantras, and rituals to overcome planetary challenges.",
    bookNow: "Book Now",
    ourExpertAstrologers: "Our Expert Astrologers",
    //consultNow: "Consult Now",
    bookSlot: "Book Slot",
    notAvailable: "Not Available",
    currentPlanetaryPositions: "Current Planetary Positions",
    lastUpdated: "Last Updated",
    viewDetailedEphemeris: "View Detailed Ephemeris",
    whatOurClientsSay: "What Our Clients Say",
    whatOurUsersSay: "What Our Users Say",
    readyToDiscoverCosmicBlueprint: "Ready to Discover Your Cosmic Blueprint?",
    startSpiritualJourney: "Start your spiritual journey with personalized astrology consultation from our expert astrologers",
    getFreeReading: "Get Free Reading",
    bookConsultation: "Book Consultation",
    
    // Horoscope API Features
    dailyHoroscope: "Daily Horoscope",
    dailyHoroscopeAPI: "Daily Horoscope (API)",
    personalizedHoroscope: "Personalized Horoscope",
    selectZodiacSign: "Select Zodiac Sign",
    getDailyHoroscope: "Get Daily Horoscope",
    generating: "Generating",
    generatePersonalizedHoroscope: "Generate Personalized Horoscope",
    birthDetails: "Birth Details",
    coordinates: "Coordinates",
    planetarySigns: "Planetary Signs",
    horoscopeReadings: "Horoscope Readings",
    dashaPeriod: "Dasha Period",
    currentDasha: "Current Dasha",
    nextDasha: "Next Dasha",
    dashaPeriods: "Dasha Periods",
    antardasha: "Antardasha",
    pratyantardasha: "Pratyantardasha",
    dashaBalance: "Dasha Balance",
    currentDashaLord: "Current Dasha Lord",
    remainingDuration: "Remaining Duration",
    detailedBalance: "Detailed Balance",
    years: "Years",
    months: "Months",
    days: "Days",
    yogas: "Yogas",
    birthLocation: "Birth Location",
    
    // Kundli Generation
    kundliGeneration: "Kundli Generation",
    pleaseEnterName: "Please enter your name",
    pleaseSelectLocation: "Please select a valid location with coordinates",
    kundliGeneratedSuccessfully: "Kundli generated successfully!",
    generatingKundli: "Generating Kundli...",
    generateKundli: "Generate Kundli",
    kundliDetails: "Kundli Details",
    locationNotSelected: "Location not selected",
    selectBirthPlace: "Select Birth Place",
    searchForBirthPlace: "Search for your birth place...",
    nakshatraDetails: "Nakshatra Details",
    pada: "Pada",
    chandraRasi: "Chandra Rasi",
    sooryaRasi: "Soorya Rasi",
    zodiac: "Zodiac",
    additionalInfo: "Additional Info",
    deity: "Deity",
    ganam: "Ganam",
    symbol: "Symbol",
    animalSign: "Animal Sign",
    nadi: "Nadi",
    color: "Color",
    bestDirection: "Best Direction",
    syllables: "Syllables",
    birthStone: "Birth Stone",
    gender: "Gender",
    planet: "Planet",
    enemyYoni: "Enemy Yoni",
    mangalDosha: "Mangal Dosha",
    hasMangalDosha: "Has Mangal Dosha",
    noMangalDosha: "No Mangal Dosha",
    doshaType: "Type",
    exceptions: "Exceptions",
    remedies: "Remedies",
    
    // Coupon Feature
    couponCode: "Pandit Code",
    couponCodeOptional: "Pandit Code (Optional)",
    enterCouponCode: "Enter pandit code for advanced features",
    validCouponMessage: "Valid pandit code! You will get advanced kundli features.",
    invalidCouponMessage: "Try without pandit or contact any Pandit near by in Madhubani for a pandit.",
    advancedFeaturesEnabled: "✨ Advanced Features Enabled",
    advancedKundliGenerated: "Advanced kundli generated successfully with pandit benefits!",
    couponValidationMessage: "Enter a valid pandit code to unlock advanced kundli features",
    
    // Kundli Matching
    kundliMatching: "Kundli Matching",
    enterGirlsName: "Please enter girl's name",
    enterBoysName: "Please enter boy's name",
    pleaseSelectValidLocation: "Please select a valid location for birth place",
    kundliMatchingCompleted: "Kundli matching completed successfully!",
    contactInformation: "Contact Information",
    enterContactPhone: "Enter contact phone number (e.g., 9876543210)",
    validPhoneNumber: "✓ Valid phone number",
    femaleDetails: "Female Details",
    maleDetails: "Male Details",
    dateOfBirth: "Date of Birth",
    timeOfBirth: "Time of Birth",
    placeOfBirth: "Place of Birth",
    searchForGirlsBirthPlace: "Search for girl's birth place...",
    searchForBoysBirthPlace: "Search for boy's birth place...",
    matchingKundlis: "Matching Kundlis...",
    checkCompatibility: "Check Compatibility",
    
    // Zodiac Signs
    aries: "Aries",
    taurus: "Taurus",
    gemini: "Gemini",
    cancer: "Cancer",
    leo: "Leo",
    virgo: "Virgo",
    libra: "Libra",
    scorpio: "Scorpio",
    sagittarius: "Sagittarius",
    capricorn: "Capricorn",
    aquarius: "Aquarius",
    pisces: "Pisces",
    
    // Error Messages
    serviceUnavailable: "Service temporarily unavailable. Please try again in a few minutes.",
    serviceNotFound: "Horoscope service not found. Please contact support.",
    requestFailed: "Failed to fetch horoscope",
    
    // Contact Us Page
    getInTouch: "Get in Touch",
    contactUsDescription: "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    message: "Message",
    sendMessage: "Send Message",
    thankYou: "Thank you!",
    pleaseWait: "Please wait...",
    contactInfo: "Contact Information",
    address: "Address",
    phone: "Phone",
    emailAddress: "Email Address",
    businessHours: "Business Hours",
    mondayToFriday: "Monday to Friday: 9:00 AM - 6:00 PM",
    saturday: "Saturday: 10:00 AM - 4:00 PM",
    sunday: "Sunday: Closed",
    
    // Panchang Page - Additional Terms
    hinduCalendar: "Hindu Calendar",
    todayPanchang: "Today's Panchang",
    selectDate: "Select Date",
    selectLocation: "Select Location",
    rahukal: "Rahukal",
    gulikakal: "Gulikakal",
    yamagandakal: "Yamagandakal",
    
    // Festivals Section
    festivals: "Festivals",
    festivalsDescription: "Hindu festivals and auspicious days",
    noFestivalsThisMonth: "No Festivals This Month",
    noFestivalsScheduled: "There are no festivals scheduled for this month",
    today: "Today",
    significance: "Significance",
    loadingFestivals: "Loading festivals...",
    errorLoadingFestivals: "Error Loading Festivals",
    tryAgain: "Try Again",
    abhijitmuhurat: "Abhijit Muhurat",
    brahmamuhurat: "Brahma Muhurat",
    amritkalam: "Amrit Kalam",
    inauspiciousTime: "Inauspicious Time",
    auspiciousTime: "Auspicious Time",
    searchLocation: "Search Location",
    noLocationFound: "No location found",
    
    // Dashboard
    welcomeBack: "Welcome Back",
    dashboardOverview: "Dashboard Overview",
    recentActivity: "Recent Activity",
    quickActions: "Quick Actions",
    editProfile: "Edit Profile",
    changePassword: "Change Password",
    privacySettings: "Privacy Settings",
    accountSettings: "Account Settings",
    preferences: "Preferences",
    
    // Auth Pages - Additional Terms
    signup: "Sign Up",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordMismatch: "Passwords do not match",
    loginSuccess: "Login successful!",
    signupSuccess: "Account created successfully!",
    loginFailed: "Login failed. Please try again.",
    signupFailed: "Signup failed. Please try again.",
    invalidCredentials: "Invalid credentials",
    accountCreated: "Account created successfully! Please login.",
    
    // Temple Pages
    templeDetails: "Temple Details",
    templeHistory: "Temple History",
    visitingHours: "Visiting Hours",
    dressCode: "Dress Code",
    howToReach: "How to Reach",
    nearbyAttractions: "Nearby Attractions",
    specialPujas: "Special Pujas",
    onlineBooking: "Online Booking",
    templeServices: "Temple Services",
    darshanTimings: "Darshan Timings",
    aartiTimings: "Aarti Timings",
    festivalSchedule: "Festival Schedule",
    
    // Music Page
    divineSongsPrayers: "Divine Songs & Prayers",
    exploreCollection: "Explore our collection of devotional songs, prayers, mantras, and meditation practices",
    songsAvailable: "songs available",
    song: "song",
    noMusicAvailable: "No {type} music available yet",
    viewMore: "View More",
    moreContentComingSoon: "More Content Coming Soon",
    continuouslyAdding: "We're continuously adding new devotional content, prayers, and spiritual practices. Each category will be expanded with more songs, mantras, and meditation sessions.",
    newContentAddedWeekly: "New content added weekly",
    highQualityAudio: "High-quality audio recordings",
    traditionalModernVersions: "Traditional and modern versions",
    loadingMusic: "Loading music...",
    //tryAgain: "Try Again",
    pageNotFound: "Page Not Found",
    requestedCategoryNotExist: "The requested music category does not exist.",
    backToSongs: "Back to Songs",
    loadingMusicType: "Loading {type} music...",
    songsAvailableCount: "{count} Songs Available",
    noMusicTypeYet: "No {type} Music Yet",
    workingOnAdding: "We're working on adding more {type} content. Check back soon for new devotional music and prayers.",
    backToAllSongs: "Back to All Songs",
    moreTypeComingSoon: "More {type} Coming Soon",
    continuouslyAddingType: "We're continuously adding new {type} content. Each song includes lyrics in both Hindi and English for your spiritual journey.",
    play: "Play",
    pause: "Pause",
    volume: "Volume",
    lyrics: "Lyrics",
    switchLanguage: "Switch Language",

    // Common Actions - Additional Terms
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    update: "Update",
    create: "Create",
    view: "View",
    download: "Download",
    print: "Print",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    clear: "Clear",
    reset: "Reset",
    back: "Back",
    next: "Next",
    previous: "Previous",
    continue: "Continue",
    finish: "Finish",
    close: "Close",
    open: "Open",
    show: "Show",
    hide: "Hide",
    expand: "Expand",
    collapse: "Collapse",
    
    // Status Messages
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Information",
    noData: "No data available",
    somethingWentWrong: "Something went wrong",
    networkError: "Network error. Please check your connection.",
    serverError: "Server error. Please try again later.",
    validationError: "Please check your input and try again.",
    
    // Auth Notification Popup
    getFreePrashad: "Get Free Prashad!",
    signupToReceiveBlessings: "Sign up to receive blessings",
    joinSpiritualCommunity: "Join our spiritual community and receive free prashad from our temple. Get access to exclusive content and blessings!",
    signupLogin: "Signup/Login",
    notificationAutoHide: "This notification will appear every 1 minute until you sign up",
    
    // Form Validation
    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    passwordTooShort: "Password must be at least 8 characters",
    passwordTooWeak: "Password is too weak",
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    agreeToTerms: "I agree to the terms and conditions",
    mustAgreeToTerms: "You must agree to the terms and conditions",
    
    // Temple Page Content
    sacredTemples: "🏛️ Sacred Temples",
    discoverDivineArchitecture: "Discover divine architecture and spiritual heritage across India's most revered temples",
    searchTemplesPlaceholder: "Search temples by name, location, or deity...",
    allTemples: "All Temples",
    shiva: "Shiva",
    vishnu: "Vishnu",
    devi: "Devi",
    explore: "Explore",
    allSacredTemples: "All Sacred Temples",
    loadMoreTemples: "Load More Temples",
    
    // Temple Detail Page Content
    backToTemples: "Back to Temples",
    aboutTheTemple: "About the Temple",
    bookPuja: "Book Puja",
    dedicatedTo: "Dedicated to:",
    locationMap: "Location Map",
    youMayAlsoLike: "You May Also Like",
    
    // Temple Detail Sections
    overview: "Overview",
    location: "Location",
    historyOfTheTemple: "History of the temple",
    significanceOfTheTemple: "Significance of the temple",
    architectureOfTheTemple: "Architecture of the temple",
    offeringsOfTheTemple: "Offerings of the temple",
    travelDetails: "Travel Details",
    travelDetailsDescription: "The below are the travel details for the temple",
    airplane: "Airplane",
    train: "Train",
    road: "Road",
    socialMedia: "Social Media",
    socialMediaDescription: "Social media associated with the temple",
    
    // Temple Status and Info
    closed: "Closed",
    allYearRound: "All Year Round",
    devoteesVisitingToday: "devotees visiting today",
    devoteesVisitDaily: "devotees visit daily",
    visitors: "visitors",
    daily: "daily",
    visit: "visit",
    hasYoga: "Present",
    noYoga: "Not Present"
  },
  hi: {
    // Navigation
    home: "होम",
    library: "गीत",
    temples: "मंदिर",
    astrology: "ज्योतिष",
    live: "लाइव",
  
    login: "लॉगिन",
    logout: "लॉगआउट",
    dashboard: "डैशबोर्ड",
    myProfile: "मेरी प्रोफ़ाइल",
    profile: "प्रोफ़ाइल",
    
    // Live Page
    liveStream: "लाइव स्ट्रीम",
    liveStreamDescription: "हमारे लाइव आध्यात्मिक सत्र और समारोहों में शामिल हों",
    aboutThisLiveStream: "इस लाइव स्ट्रीम के बारे में",
    liveStreamAboutText: "हमारे लाइव आध्यात्मिक सत्र में आपका स्वागत है। यहाँ आप वास्तविक समय में प्रार्थना, समारोह और आध्यात्मिक चर्चाओं में भाग ले सकते हैं। हमारे अनुभवी पुजारी और आध्यात्मिक गाइड विभिन्न अनुष्ठान करेंगे और आपके सवालों के जवाब देंगे।",
    schedule: "समय सारणी",
    participation: "भागीदारी",
    dailyPrayers: "दैनिक प्रार्थना: सुबह 6:00 - 7:00",
    eveningAarti: "शाम की आरती: शाम 7:00 - 8:00",
    participationText: "प्रार्थना में शामिल हों, चैट में सवाल पूछें और हमारे साथ आध्यात्मिक यात्रा में भाग लें।",
    
    // Live Videos
    currentlyLive: "वर्तमान में लाइव",
    noLiveVideos: "इस समय कोई लाइव वीडियो नहीं",
    watch: "देखें",
    liveStatus: "लाइव",
    refresh: "रिफ्रेश करें",
    loading: "लोड हो रहा है...",
    
    // Video Detail Page
    watchLive: "लाइव देखें",
    description: "विवरण",
    readMore: "और पढ़ें",
    readLess: "कम पढ़ें",
    backToLive: "लाइव पर वापस जाएं",
    
    // Library Sections
    sanatanSahitya: "सनातन साहित्य",
    readAllArticles: "सभी लेख पढ़ें",
    arti: "आरती",
    artiDescription: "भक्ति गीत और प्रार्थना",
    chalisa: "चालीसा",
    chalisaDescription: "दिव्य की प्रशंसा में चालीस छंद",
    mantra: "मंत्र",
    mantraDescription: "पवित्र ध्वनियाँ और कंपन",
    incarnations: "देवी-देवताओं के अवतार",
    incarnationsDescription: "दिव्य अभिव्यक्तियों की कहानियाँ",
    spiritualStories: "आध्यात्मिक कहानियाँ",
    spiritualStoriesDescription: "प्राचीन ज्ञान और शिक्षाएं",
    meditation: "ध्यान",
    meditationDescription: "निर्देशित आध्यात्मिक अभ्यास",
    
    // Common
    exploreAnantAradhyaServices: "अनंत आराध्या सेवाओं का अन्वेषण करें",
    helpAndSupport: "पूजा बुकिंग के लिए सहायता और समर्थन",
    youCanCallUs: "आप सुबह 10 बजे से शाम 8 बजे तक हमें कॉल कर सकते हैं",
    emailUs: "हमें ईमेल करें",
    whatsappUs: "हमें व्हाट्सऐप करें",
    toCheckAllAvailable: "सभी उपलब्ध पूजा और ऑफर देखने के लिए:",
    loginCreateAccount: "लॉगिन / खाता बनाएं",
    accountDetails: "खाता विवरण",
    
    // Video Detail Page
    views: "दृश्य",
    videoInfo: "वीडियो जानकारी",
    channel: "चैनल",
    status: "स्थिति",
    watchOnYouTube: "YouTube पर देखें",
    
    // Panchang Page
    panchang: "पंचांग",
    panchangDescription: "दैनिक ज्योतिषीय जानकारी और शुभ समय",
    detailedPanchang: "विस्तृत पंचांग जानकारी",
    vaara: "वार",
    sunrise: "सूर्योदय",
    sunset: "सूर्यास्त",
    moonrise: "चंद्रोदय",
    moonset: "चंद्रास्त",
    nakshatra: "नक्षत्र",
    tithi: "तिथि",
    karana: "करण",
    yoga: "योग",
    lord: "स्वामी",
    name: "नाम",
    vedicName: "वैदिक नाम",
    paksha: "पक्ष",
    start: "शुरुआत",
    end: "अंत",
    
    // Live Darshan Page
    liveNow: "अभी लाइव",
    devoteesWatching: "भक्त देख रहे हैं",
    liveDarshan: "लाइव दर्शन",
    liveDarshanDescription: "भारत भर के पवित्र मंदिरों से वास्तविक समय में दिव्य दर्शन का अनुभव करें",
    watching: "देख रहे हैं",
    joinDivineExperience: "दिव्य अनुभव में शामिल हों",
    joinPrayer: "प्रार्थना में शामिल हों",
    share: "साझा करें",
    audio: "ऑडियो",
    fullscreen: "पूर्ण स्क्रीन",
    nextEveningAarti: "अगला: शाम 6:00 बजे शाम की आरती",
    joinCommunity: "समुदाय में शामिल हों",
    liveChat: "लाइव चैट",
    typeMessage: "अपना संदेश टाइप करें...",
    prayerRequests: "प्रार्थना अनुरोध",
    submitPrayerRequest: "प्रार्थना अनुरोध जमा करें",
    otherSacredTemples: "अन्य पवित्र मंदिर (जल्द आ रहे हैं)",
    comingSoon: "जल्द आ रहा है",
    getNotifiedWhenMoreTemples: "अधिक मंदिर लाइव होने पर सूचना प्राप्त करें",
    beFirstToExperience: "इन पवित्र मंदिरों से दिव्य दर्शन का अनुभव करने वाले पहले व्यक्ति बनें",
    enterEmail: "अपना ईमेल दर्ज करें",
    notifyMe: "मुझे सूचित करें",
    neverMissSacredMoment: "कभी भी पवित्र क्षण न चूकें",
    downloadAppForNotifications: "लाइव दर्शन और विशेष कार्यक्रमों की सूचनाएं प्राप्त करने के लिए हमारा ऐप डाउनलोड करें",
    downloadApp: "ऐप डाउनलोड करें",
    enableNotifications: "सूचनाएं सक्षम करें",
    divineConnection: "दिव्य संबंध",
    footerDescription: "प्राचीन परंपराओं को संरक्षित करते हुए प्रौद्योगिकी के माध्यम से भक्तों को दिव्य अनुभवों से जोड़ना।",
    quickLinks: "त्वरित लिंक",
    followUs: "हमें फॉलो करें",
    allRightsReserved: "सभी अधिकार सुरक्षित।",
    
    // Homepage Content
    experienceDivineDarshan: "✨ कभी भी, कहीं भी दिव्य दर्शन का अनुभव करें",
    connectWithSacredTemples: "पवित्र मंदिरों से जुड़ें, लाइव दर्शन में भाग लें, और अपने दरवाजे पर आशीर्वाद प्राप्त करें।",
    startYourJourney: "🔶 अपनी यात्रा शुरू करें",
    watchLiveDarshan: "⚪ लाइव दर्शन देखें",
    bridgingTraditionWithTechnology: "परंपरा को प्रौद्योगिकी से जोड़ना",
    traditionTechnologySubtitle: "सदियों से, मंदिर आध्यात्मिकता के केंद्र में रहे हैं। हमारा मंच आपके डिजिटल दरवाजे पर पवित्र अनुभव लाता है, प्राचीन परंपराओं को संरक्षित करते हुए आधुनिक सुविधा को अपनाता है।",
    learnMore: "👉 अधिक जानें",
    divineServicesAtYourFingertips: "आपकी उंगलियों पर दिव्य सेवाएं",
    liveDarshanTitle: "📡 लाइव दर्शन",
    //liveDarshanDescription: "दुनिया में कहीं से भी पवित्र दर्शन में शामिल हों",
    joinNow: "अभी शामिल हों",
    astrologyConsultationTitle: "🔮 ज्योतिष परामर्श",
    astrologyConsultationDescription: "विशेषज्ञों से व्यक्तिगत मार्गदर्शन",
    consultNow: "अभी परामर्श करें",
    dailyPanchangTitle: "📅 दैनिक पंचांग",
    dailyPanchangDescription: "आपका दैनिक आध्यात्मिक कैलेंडर",
    viewPanchang: "पंचांग देखें",
    trustedByPandits: "भारत भर के उचैठ पंडितों",
    whatDevoteesSay: "भक्त क्या कहते हैं",
    avirajReview: "लाइव दर्शन सुविधा ने मेरी दैनिक प्रार्थनाओं को बदल दिया है। यात्रा के दौरान भी मैं अपने पसंदीदा मंदिर से जुड़ सकता हूं।",
    akashReview: "मंदिर सेवाओं ने सब कुछ सुविधाजनक और प्रामाणिक बना दिया है। अनुभव उत्कृष्ट है।",
    featuredTemples: "विशेष मंदिर",
    goldenTemple: "स्वर्ण मंदिर",
    amritsarPunjab: "अमृतसर, पंजाब",
    kashiVishwanath: "काशी विश्वनाथ",
    varanasiUp: "वाराणसी, उत्तर प्रदेश",
    tirupatiBalaji: "तिरुपति बालाजी",
    tirupatiAp: "तिरुपति, आंध्र प्रदेश",
    meenakshiTemple: "मीनाक्षी मंदिर",
    maduraiTn: "मदुरै, तमिलनाडु",
    viewAllTemples: "👉 सभी मंदिर देखें",
    beginSpiritualJourney: "आज ही अपनी आध्यात्मिक यात्रा शुरू करें",
    joinMillionsDevotees: "हमारे मंच के माध्यम से दिव्य आशीर्वाद का अनुभव करने वाले लाखों भक्तों में शामिल हों।",
    //downloadApp: "📲 ऐप डाउनलोड करें",
    exploreServices: "🌸 सेवाओं का अन्वेषण करें",
    
    // Astrology Page
    vedicAstrology: "वैदिक ज्योतिष",
    discoverCosmicBlueprint: "अपने ब्रह्मांडीय नक्शे की खोज करें और प्राचीन ज्ञान के साथ जीवन की यात्रा को नेविगेट करें",
    getFreeHoroscope: "मुफ्त राशिफल प्राप्त करें",
    consultAstrologer: "ज्योतिषी से परामर्श करें",
    todaysHoroscope: "आज का राशिफल",
    love: "प्रेम",
    career: "करियर",
    health: "स्वास्थ्य",
    luckyNumber: "भाग्यशाली संख्या",
    luckyColor: "भाग्यशाली रंग",
    astrologyServices: "ज्योतिष सेवाएं",
    birthChartAnalysis: "जन्म कुंडली विश्लेषण",
    birthChartDescription: "आपकी जन्म कुंडली का व्यापक विश्लेषण जो व्यक्तित्व लक्षण, ताकत और जीवन पथ को प्रकट करता है।",
    loveCompatibility: "प्रेम अनुकूलता",
    loveCompatibilityDescription: "रिश्ते की अनुकूलता की खोज करें और विस्तृत अंतर्दृष्टि के साथ अपनी रोमांटिक गतिशीलता को समझें।",
    careerGuidance: "करियर मार्गदर्शन",
    careerGuidanceDescription: "करियर निर्णय, नौकरी परिवर्तन और व्यापारिक उद्यमों के लिए पेशेवर ज्योतिष परामर्श।",
    gemstoneConsultation: "रत्न परामर्श",
    gemstoneConsultationDescription: "बढ़ी हुई सकारात्मक ऊर्जा के लिए आपकी जन्म कुंडली के आधार पर व्यक्तिगत रत्न सिफारिशें।",
    muhuratSelection: "मुहूर्त चयन",
    muhuratSelectionDescription: "महत्वपूर्ण घटनाओं, समारोहों और नई शुरुआत के लिए सबसे शुभ समय खोजें।",
    remedialSolutions: "उपचारात्मक समाधान",
    remedialSolutionsDescription: "ग्रहों की चुनौतियों को दूर करने के लिए मंत्र, यंत्र और अनुष्ठान सहित शक्तिशाली उपचार।",
    bookNow: "अभी बुक करें",
    ourExpertAstrologers: "हमारे विशेषज्ञ ज्योतिषी",
    //consultNow: "अभी परामर्श करें",
    bookSlot: "स्लॉट बुक करें",
    notAvailable: "उपलब्ध नहीं",
    currentPlanetaryPositions: "वर्तमान ग्रह स्थिति",
    lastUpdated: "अंतिम अपडेट",
    viewDetailedEphemeris: "विस्तृत एफेमेरिस देखें",
    whatOurClientsSay: "हमारे ग्राहक क्या कहते हैं",
    whatOurUsersSay: "हमारे उपयोगकर्ता क्या कहते हैं",
    readyToDiscoverCosmicBlueprint: "अपने ब्रह्मांडीय नक्शे की खोज के लिए तैयार हैं?",
    startSpiritualJourney: "हमारे विशेषज्ञ ज्योतिषियों से व्यक्तिगत ज्योतिष परामर्श के साथ अपनी आध्यात्मिक यात्रा शुरू करें",
    getFreeReading: "मुफ्त रीडिंग प्राप्त करें",
    bookConsultation: "परामर्श बुक करें",
    
    // Horoscope API Features
    dailyHoroscope: "दैनिक राशिफल",
    dailyHoroscopeAPI: "दैनिक राशिफल (API)",
    personalizedHoroscope: "व्यक्तिगत राशिफल",
    selectZodiacSign: "राशि चुनें",
    getDailyHoroscope: "दैनिक राशिफल प्राप्त करें",
    generating: "जेनरेट हो रहा है",
    generatePersonalizedHoroscope: "व्यक्तिगत राशिफल जेनरेट करें",
    birthDetails: "जन्म विवरण",
    coordinates: "निर्देशांक",
    planetarySigns: "ग्रहीय राशि",
    horoscopeReadings: "राशिफल रीडिंग",
    dashaPeriod: "दशा अवधि",
    currentDasha: "वर्तमान दशा",
    nextDasha: "अगली दशा",
    dashaPeriods: "दशा अवधि",
    antardasha: "अंतरदशा",
    pratyantardasha: "प्रत्‍यंतरदशा",
    dashaBalance: "दशा शेष",
    currentDashaLord: "वर्तमान दशा स्वामी",
    remainingDuration: "शेष अवधि",
    detailedBalance: "विस्तृत शेष",
    years: "वर्ष",
    months: "महीने",
    days: "दिन",
    yogas: "योग",
    birthLocation: "जन्म स्थान",
    
    // Kundli Generation
    kundliGeneration: "कुंडली जेनरेशन",
    pleaseEnterName: "कृपया अपना नाम दर्ज करें",
    pleaseSelectLocation: "कृपया निर्देशांक के साथ एक वैध स्थान चुनें",
    kundliGeneratedSuccessfully: "कुंडली सफलतापूर्वक जेनरेट की गई!",
    generatingKundli: "कुंडली जेनरेट हो रही है...",
    generateKundli: "कुंडली जेनरेट करें",
    kundliDetails: "कुंडली विवरण",
    locationNotSelected: "स्थान चयनित नहीं",
    selectBirthPlace: "जन्म स्थान चुनें",
    searchForBirthPlace: "अपने जन्म स्थान की खोज करें...",
    nakshatraDetails: "नक्षत्र विवरण",
    pada: "पद",
    chandraRasi: "चंद्र राशि",
    sooryaRasi: "सूर्य राशि",
    zodiac: "राशि",
    additionalInfo: "अतिरिक्त जानकारी",
    deity: "देवता",
    ganam: "गणम",
    symbol: "प्रतीक",
    animalSign: "पशु चिह्न",
    nadi: "नाड़ी",
    color: "रंग",
    bestDirection: "सर्वोत्तम दिशा",
    syllables: "अक्षर",
    birthStone: "जन्म रत्न",
    gender: "लिंग",
    planet: "ग्रह",
    enemyYoni: "शत्रु योनी",
    mangalDosha: "मंगल दोष",
    hasMangalDosha: "मंगल दोष है",
    noMangalDosha: "मंगल दोष नहीं है",
    doshaType: "प्रकार",
    exceptions: "अपवाद",
    remedies: "उपाय",
    
    // Coupon Feature
    couponCode: "पंडित कोड",
    couponCodeOptional: "पंडित कोड (वैकल्पिक)",
    enterCouponCode: "उन्नत सुविधाओं के लिए पंडित कोड दर्ज करें",
    validCouponMessage: "वैध पंडित कोड! आपको उन्नत कुंडली सुविधाएं मिलेंगी।",
    invalidCouponMessage: "कूपन के बिना प्रयास करें या मधुबनी के पास किसी पंडित से संपर्क करें।",
    advancedFeaturesEnabled: "✨ उन्नत सुविधाएं सक्षम",
    advancedKundliGenerated: "कूपन लाभ के साथ उन्नत कुंडली सफलतापूर्वक जेनरेट की गई!",
    couponValidationMessage: "उन्नत कुंडली सुविधाओं को अनलॉक करने के लिए एक वैध पंडित कोड दर्ज करें",
    
    // Kundli Matching
    kundliMatching: "कुंडली मिलान",
    enterGirlsName: "कृपया लड़की का नाम दर्ज करें",
    enterBoysName: "कृपया लड़के का नाम दर्ज करें",
    pleaseSelectValidLocation: "कृपया जन्म स्थान के लिए एक वैध स्थान चुनें",
    kundliMatchingCompleted: "कुंडली मिलान सफलतापूर्वक पूरा हुआ!",
    contactInformation: "संपर्क जानकारी",
    enterContactPhone: "संपर्क फोन नंबर दर्ज करें (जैसे, 9876543210)",
    validPhoneNumber: "✓ वैध फोन नंबर",
    femaleDetails: "महिला विवरण",
    maleDetails: "पुरुष विवरण",
    dateOfBirth: "जन्म तिथि",
    timeOfBirth: "जन्म समय",
    placeOfBirth: "जन्म स्थान",
    searchForGirlsBirthPlace: "लड़की के जन्म स्थान की खोज करें...",
    searchForBoysBirthPlace: "लड़के के जन्म स्थान की खोज करें...",
    matchingKundlis: "कुंडली मिलान हो रहा है...",
    checkCompatibility: "अनुकूलता जांचें",
    
    // Zodiac Signs
    aries: "मेष",
    taurus: "वृषभ",
    gemini: "मिथुन",
    cancer: "कर्क",
    leo: "सिंह",
    virgo: "कन्या",
    libra: "तुला",
    scorpio: "वृश्चिक",
    sagittarius: "धनु",
    capricorn: "मकर",
    aquarius: "कुंभ",
    pisces: "मीन",
    
    // Error Messages
    serviceUnavailable: "सेवा अस्थायी रूप से उपलब्ध नहीं है। कृपया कुछ मिनटों में पुनः प्रयास करें।",
    serviceNotFound: "राशिफल सेवा नहीं मिली। कृपया सहायता से संपर्क करें।",
    requestFailed: "राशिफल प्राप्त करने में विफल",
    
    // Contact Us Page
    contactUs: "संपर्क करें",
    getInTouch: "संपर्क में रहें",
    contactUsDescription: "हम आपसे सुनना चाहते हैं। हमें संदेश भेजें और हम जल्द से जल्द जवाब देंगे।",
    fullName: "पूरा नाम",
    email: "ईमेल",
    phoneNumber: "फोन नंबर",
    message: "संदेश",
    sendMessage: "संदेश भेजें",
    thankYou: "धन्यवाद!",
    pleaseWait: "कृपया प्रतीक्षा करें...",
    contactInfo: "संपर्क जानकारी",
    address: "पता",
    phone: "फोन",
    emailAddress: "ईमेल पता",
    businessHours: "कार्य समय",
    mondayToFriday: "सोमवार से शुक्रवार: सुबह 9:00 - शाम 6:00",
    saturday: "शनिवार: सुबह 10:00 - शाम 4:00",
    sunday: "रविवार: बंद",
    
    // Panchang Page - Additional Terms
    hinduCalendar: "हिंदू कैलेंडर",
    todayPanchang: "आज का पंचांग",
    selectDate: "तारीख चुनें",
    selectLocation: "स्थान चुनें",
    rahukal: "राहुकाल",
    gulikakal: "गुलिकाकाल",
    yamagandakal: "यमगंडकाल",
    
    // Festivals Section
    festivals: "त्योहार",
    festivalsDescription: "हिंदू त्योहार और शुभ दिन",
    noFestivalsThisMonth: "इस महीने कोई त्योहार नहीं",
    noFestivalsScheduled: "इस महीने के लिए कोई त्योहार निर्धारित नहीं है",
    today: "आज",
    significance: "महत्व",
    loadingFestivals: "त्योहार लोड हो रहे हैं...",
    errorLoadingFestivals: "त्योहार लोड करने में त्रुटि",
    tryAgain: "पुनः प्रयास करें",
    abhijitmuhurat: "अभिजीत मुहूर्त",
    brahmamuhurat: "ब्रह्म मुहूर्त",
    amritkalam: "अमृत काल",
    inauspiciousTime: "अशुभ समय",
    auspiciousTime: "शुभ समय",
    searchLocation: "स्थान खोजें",
    noLocationFound: "कोई स्थान नहीं मिला",
    
    // Dashboard
    welcomeBack: "वापस स्वागत है",
    dashboardOverview: "डैशबोर्ड अवलोकन",
    recentActivity: "हाल की गतिविधि",
    quickActions: "त्वरित कार्य",
    editProfile: "प्रोफ़ाइल संपादित करें",
    changePassword: "पासवर्ड बदलें",
    privacySettings: "गोपनीयता सेटिंग्स",
    accountSettings: "खाता सेटिंग्स",
    preferences: "प्राथमिकताएं",
    
    // Auth Pages - Additional Terms
    signup: "साइन अप",
    createAccount: "खाता बनाएं",
    alreadyHaveAccount: "पहले से खाता है?",
    dontHaveAccount: "खाता नहीं है?",
    forgotPassword: "पासवर्ड भूल गए?",
    resetPassword: "पासवर्ड रीसेट करें",
    newPassword: "नया पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    passwordMismatch: "पासवर्ड मेल नहीं खाते",
    loginSuccess: "लॉगिन सफल!",
    signupSuccess: "खाता सफलतापूर्वक बनाया गया!",
    loginFailed: "लॉगिन असफल। कृपया पुनः प्रयास करें।",
    signupFailed: "साइन अप असफल। कृपया पुनः प्रयास करें।",
    invalidCredentials: "अमान्य क्रेडेंशियल्स",
    accountCreated: "खाता सफलतापूर्वक बनाया गया! कृपया लॉगिन करें।",
    
    // Temple Pages
    templeDetails: "मंदिर विवरण",
    templeHistory: "मंदिर का इतिहास",
    visitingHours: "दर्शन समय",
    dressCode: "ड्रेस कोड",
    howToReach: "कैसे पहुंचें",
    nearbyAttractions: "निकटवर्ती आकर्षण",
    specialPujas: "विशेष पूजा",
    onlineBooking: "ऑनलाइन बुकिंग",
    templeServices: "मंदिर सेवाएं",
    darshanTimings: "दर्शन समय",
    aartiTimings: "आरती समय",
    festivalSchedule: "त्योहार कार्यक्रम",
    
    // Music Page
    divineSongsPrayers: "दिव्य गीत और प्रार्थना",
    exploreCollection: "भक्ति गीत, प्रार्थना, मंत्र और ध्यान अभ्यास के हमारे संग्रह का अन्वेषण करें",
    songsAvailable: "गीत उपलब्ध",
    song: "गीत",
    noMusicAvailable: "अभी तक कोई {type} संगीत उपलब्ध नहीं",
    viewMore: "और देखें",
    moreContentComingSoon: "और सामग्री जल्द आ रही है",
    continuouslyAdding: "हम लगातार नई भक्ति सामग्री, प्रार्थना और आध्यात्मिक अभ्यास जोड़ रहे हैं। प्रत्येक श्रेणी को अधिक गीत, मंत्र और ध्यान सत्रों के साथ विस्तारित किया जाएगा।",
    newContentAddedWeekly: "साप्ताहिक नई सामग्री जोड़ी जाती है",
    highQualityAudio: "उच्च गुणवत्ता वाले ऑडियो रिकॉर्डिंग",
    traditionalModernVersions: "पारंपरिक और आधुनिक संस्करण",
    loadingMusic: "संगीत लोड हो रहा है...",
    //tryAgain: "पुनः प्रयास करें",
    pageNotFound: "पेज नहीं मिला",
    requestedCategoryNotExist: "अनुरोधित संगीत श्रेणी मौजूद नहीं है।",
    backToSongs: "गीतों पर वापस जाएं",
    loadingMusicType: "{type} संगीत लोड हो रहा है...",
    songsAvailableCount: "{count} गीत उपलब्ध",
    noMusicTypeYet: "अभी तक कोई {type} संगीत नहीं",
    workingOnAdding: "हम अधिक {type} सामग्री जोड़ने पर काम कर रहे हैं। नए भक्ति संगीत और प्रार्थना के लिए जल्द ही वापस जांचें।",
    backToAllSongs: "सभी गीतों पर वापस जाएं",
    moreTypeComingSoon: "अधिक {type} जल्द आ रहा है",
    continuouslyAddingType: "हम लगातार नई {type} सामग्री जोड़ रहे हैं। प्रत्येक गीत में आपकी आध्यात्मिक यात्रा के लिए हिंदी और अंग्रेजी दोनों में गीत शामिल हैं।",
    play: "चलाएं",
    pause: "रोकें",
    volume: "आवाज़",
    lyrics: "गीत",
    switchLanguage: "भाषा बदलें",

    // Common Actions - Additional Terms
    submit: "जमा करें",
    cancel: "रद्द करें",
    save: "सहेजें",
    edit: "संपादित करें",
    delete: "हटाएं",
    update: "अपडेट करें",
    create: "बनाएं",
    view: "देखें",
    download: "डाउनलोड करें",
    print: "प्रिंट करें",
    search: "खोजें",
    filter: "फिल्टर करें",
    sort: "क्रमबद्ध करें",
    clear: "साफ करें",
    reset: "रीसेट करें",
    back: "वापस",
    next: "अगला",
    previous: "पिछला",
    continue: "जारी रखें",
    finish: "समाप्त करें",
    close: "बंद करें",
    open: "खोलें",
    show: "दिखाएं",
    hide: "छुपाएं",
    expand: "विस्तार करें",
    collapse: "संकुचित करें",
    
    // Status Messages
    success: "सफलता",
    error: "त्रुटि",
    warning: "चेतावनी",
    info: "जानकारी",
    noData: "कोई डेटा उपलब्ध नहीं",
    somethingWentWrong: "कुछ गलत हुआ",
    networkError: "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
    serverError: "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
    validationError: "कृपया अपना इनपुट जांचें और पुनः प्रयास करें।",
    
    // Auth Notification Popup
    getFreePrashad: "मुफ्त प्रसाद पाएं!",
    signupToReceiveBlessings: "आशीर्वाद पाने के लिए साइन अप करें",
    joinSpiritualCommunity: "हमारे आध्यात्मिक समुदाय में शामिल हों और हमारे मंदिर से मुफ्त प्रसाद प्राप्त करें। विशेष सामग्री और आशीर्वाद तक पहुंच प्राप्त करें!",
    signupLogin: "साइन अप/लॉगिन",
    notificationAutoHide: "यह सूचना हर 1 मिनट में तब तक दिखाई देगी जब तक आप साइन अप नहीं करते",
    
    // Form Validation
    required: "यह फील्ड आवश्यक है",
    invalidEmail: "कृपया एक वैध ईमेल पता दर्ज करें",
    invalidPhone: "कृपया एक वैध फोन नंबर दर्ज करें",
    passwordTooShort: "पासवर्ड कम से कम 8 अक्षर का होना चाहिए",
    passwordTooWeak: "पासवर्ड बहुत कमजोर है",
    termsAndConditions: "नियम और शर्तें",
    privacyPolicy: "गोपनीयता नीति",
    agreeToTerms: "मैं नियम और शर्तों से सहमत हूं",
    mustAgreeToTerms: "आपको नियम और शर्तों से सहमत होना होगा",
    
    // Temple Page Content
    sacredTemples: "🏛️ पवित्र मंदिर",
    discoverDivineArchitecture: "भारत के सबसे पूज्य मंदिरों में दिव्य वास्तुकला और आध्यात्मिक विरासत की खोज करें",
    searchTemplesPlaceholder: "नाम, स्थान या देवता से मंदिर खोजें...",
    allTemples: "सभी मंदिर",
    shiva: "शिव",
    vishnu: "विष्णु",
    devi: "देवी",
    explore: "अन्वेषण करें",
    allSacredTemples: "सभी पवित्र मंदिर",
    loadMoreTemples: "और मंदिर लोड करें",
    
    // Temple Detail Page Content
    backToTemples: "मंदिरों पर वापस जाएं",
    aboutTheTemple: "मंदिर के बारे में",
    bookPuja: "पूजा बुक करें",
    dedicatedTo: "समर्पित:",
    locationMap: "स्थान का नक्शा",
    youMayAlsoLike: "आपको यह भी पसंद आ सकता है",
    
    // Temple Detail Sections
    overview: "अवलोकन",
    location: "स्थान",
    historyOfTheTemple: "मंदिर का इतिहास",
    significanceOfTheTemple: "मंदिर का महत्व",
    architectureOfTheTemple: "मंदिर की वास्तुकला",
    offeringsOfTheTemple: "मंदिर की भेंट",
    travelDetails: "यात्रा का विवरण",
    travelDetailsDescription: "नीचे मंदिर के लिए यात्रा का विवरण है",
    airplane: "हवाई जहाज",
    train: "ट्रेन",
    road: "सड़क",
    socialMedia: "सोशल मीडिया",
    socialMediaDescription: "मंदिर से जुड़े सोशल मीडिया",
    
    // Temple Status and Info
    closed: "बंद",
    allYearRound: "साल भर",
    devoteesVisitingToday: "भक्त आज दौरा कर रहे हैं",
    devoteesVisitDaily: "भक्त दैनिक दौरा करते हैं",
    visitors: "दर्शक",
    daily: "दैनिक",
    visit: "दौरा",
    hasYoga: "उपस्थित",
    noYoga: "उपस्थित नहीं"
  }
};
